import { Overlay, OverlayConfig } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable, Injector, TemplateRef, Type, inject } from '@angular/core';

import { ModalPopupComponent } from './modal-popup.component';
import { ModalPopupOverlayRef, ModalConfig } from './modal-popup-ref';

@Injectable({
  providedIn: 'root'
})
export class ModalPopupService {
  private overlay = inject(Overlay);
  private injector = inject(Injector);

  openDialogs = [];

  open<R = any, T = any>(content: string | TemplateRef<any> | Type<any>, data: ModalConfig): ModalPopupOverlayRef<R> {
    const configs = new OverlayConfig({
      hasBackdrop: !data.hideBackdrop ? true : false,
      panelClass: ['modal', 'd-block', data.panelClass],
      positionStrategy: this.overlay.position()
        .global()
        .centerHorizontally()
        .centerVertically(),
      // scrollStrategy: this.overlay.scrollStrategies.block()
      scrollStrategy: this.overlay.scrollStrategies.reposition({
        autoClose: false
      }),
    });

    const overlayRef = this.overlay.create(configs);
    const myOverlayRef = new ModalPopupOverlayRef<R, T>(overlayRef, content, data);


    const injector = this.createInjector(myOverlayRef, this.injector);
    overlayRef.attach(new ComponentPortal(ModalPopupComponent, null, injector));
    if (!data.disableBackdropClick) {
      overlayRef.backdropClick().subscribe(() => {
        myOverlayRef.close();
      });
    }

    this.openDialogs.push(myOverlayRef);

    return myOverlayRef;
  }

  createInjector(ref: ModalPopupOverlayRef, inj: Injector) {
    return Injector.create({
      parent: inj,
      providers: [
        { provide: ModalPopupOverlayRef, useValue: ref }
      ]
    });
  }

  closeAll(): void {
    this.openDialogs.forEach(ref => {
      ref.close();
    });
  }
}